import React, { useReducer } from "react";
import axios from "axios";
import authContext from "./authContext";
import authReducer from "./authReducer";
import setAuthToken from "../../utilities/setAuthToken";
import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  CLEAR_ERRORS,
  LOADING
} from "./types";

const AuthState = props => {
  const initialState = {
    admin_access: localStorage.getItem("admin_access"),
    isAuthenticated: null,
    loading: false,
    admin: null,
    error: null
  };

  const [state, dispatch] = useReducer(authReducer, initialState);

  //Load User
  const loadUser = async () => {
    if (localStorage.admin_access) {
      setAuthToken(localStorage.admin_access);
    }
    dispatch({
      type: LOADING,
      payload: null
    });
    try {
      const res = await axios.get("/api/auth");

      dispatch({
        type: USER_LOADED,
        admin: res.data.admin
      });
    } catch (err) {
      dispatch({ type: AUTH_ERROR });
    }
  };

  //Register User
  const register = async formData => {
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    dispatch({
      type: LOADING,
      payload: null
    });

    try {
      const res = await axios.post("/api/auth/create-admin", formData, config);
      if (res.data.msg === "Email already in use") {
        alert("Email already in use");
      }
      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data
      });
      loadUser();
    } catch (err) {
      alert(err.response.data.msg);
    }
  };

  //Login User
  const loginUser = async formData => {
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };

    try {
      const res = await axios.post("/api/auth", formData, config);

      if (res.data === "Invalid password" || res.data === "Invalid email") {
        alert("Invalid Credentials");
      }

      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data
      });
      loadUser();
    } catch (err) {
      alert("Invalid Credentials");
    }
  };

  //Logout
  const logoutUser = () => {
    dispatch({ type: LOGOUT });
  };

  //Clear Errors
  const clearErrors = () => dispatch({ type: CLEAR_ERRORS });

  return (
    <authContext.Provider
      value={{
        admin_access: state.admin_access,
        isAuthenticated: state.isAuthenticated,
        admin: state.admin,
        loading: state.loading,
        error: state.error,
        register,
        loadUser,
        loginUser,
        logoutUser,
        clearErrors
      }}
    >
      {props.children}
    </authContext.Provider>
  );
};

export default AuthState;
